import { atom } from "recoil";
export const availableUserRoleStates = atom({
    key: "availableUserRoleStates", // unique ID (with respect to other atoms/selectors)
    default: [], // default value (aka initial value)
});
